export enum States {
	FOLDER_VIEW = 'folder-view',
	ARCHIVE_VIEW = 'archive-view',
	LICENSE_MANAGEMENT_VIEW = 'license-management-view',
	NO_BREADCRUMBS = 'none',
	USER_SETTINGS = 'user-settings'
}
